/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { getApiTargetInfo } from 'core'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import {
  getFailCodeMgmtInfo,
  postFailCodeMgmtInfo,
  deleteFailCodeMgmtInfo,
} from 'api/pgads.js'
import CommonScreen from './CommonScreen'
import { Input, Button } from 'antd'
import { STORE_FAILCODE } from 'core/action-names'
const headers = [
  strCol({
    ident: 'code',
    display: 'Code',
    isKey: true,
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 780,
    alignment: 'left',
    isRequired: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const retrieveTask = apiTargetInfo => getFailCodeMgmtInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postFailCodeMgmtInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteFailCodeMgmtInfo(apiTargetInfo)(data)

const title = 'Fail Code Management'

const FailCodeMgmt = props => {
  // const [] = useState({ code: undefined, description: undefined })
  const [insertEvent, setInsertEvent] = useState(false)
  // const [] = useState(null)

  // const setData = data => {
  //   setInsertData({ ...insertData, ...data })
  // }
  // const validateData = () => {
  //   const { code } = insertData
  //   if (code === undefined) message.error('Please Insert Code to Save')
  //   else return true
  //   return false
  // }
  // const onAdd = ({ hide, retrieve }) => {
  //   const validate = validateData()
  //   if (validate)
  //     modifyTask(props.apiTargetInfo)([insertData]).fork(setErr, _ => {
  //       message.info('Data Saved')
  //       setInsertEvent(!hide)
  //       setInsertData({ code: undefined, description: undefined })
  //       retrieve && retrieve()
  //     })
  // }
  // const onCancel = () => {
  //   setInsertEvent(false)
  // }

  const onRetrieveData = data => {
    props.saveFailcode(data)
  }

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          width: '100%',
          gridColumnGap: '10px',
          gridTemplateColumns: '50px min-content 100px auto min-content ',
        }}
      >
        <div
          style={{
            display: 'grid',
            justifyContent: 'center',
            alignContent: 'center',
          }}
        >
          Code :
        </div>
        <div>
          <Input
            placeholder="Code"
            maxLength={5}
            value={insertData.code}
            onChange={value =>
              setInsertData({ ...insertData, code: value.target.value })
            }
            style={{ width: '200px' }}
          />
        </div>
        <div
          style={{
            textAlign: 'end',
            display: 'grid',
            justifyContent: 'center',
            alignContent: 'center',
          }}
        >
          Description :
        </div>
        <div>
          <Input
            placeholder="Description"
            value={insertData.description}
            onChange={value =>
              setInsertData({ ...insertData, description: value.target.value })
            }
            allowClear
          />
        </div>
        <div style={{ display: 'flex' }}>
          <Button
            type="primary"
            onClick={() => onAdd(true)}
            style={{ marginRight: '20px' }}
          >
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>

          <Button
            type="danger"
            onClick={onCancel}
            style={{ marginLeft: '10px', marginRight: '20px' }}
          >
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  return (
    <CommonScreen
      title={title}
      header={headers}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.code}
      autoRetrieve
      sortOptions={[{ ident: 'code', display: 'Code', sortOrder: 'asc' }]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={80}
      onInsertEvent={b => setInsertEvent(b)}
      onRetrieveData={onRetrieveData}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

const mapDispathcToProps = dispatch => ({
  saveFailcode: failCode =>
    dispatch({ type: STORE_FAILCODE, payload: failCode }),
})

export default connect(mapStateToProps, mapDispathcToProps)(FailCodeMgmt)
